import type { LobbyPlayer } from "./LobbyPlayer.js";
import type { Ruleset } from "../game/Ruleset.js";
import type { GameMode } from "../game/GameMode.js";


export class LobbySummary {
    public readonly lobbyID: string;
    public readonly mode: GameMode;
    public readonly settings: Ruleset;
    public readonly player1: LobbyPlayer | null;
    public readonly player2: LobbyPlayer | null;

    constructor(
        lobbyID: string,
        mode: GameMode,
        settings: Ruleset,
        player1: LobbyPlayer | null,
        player2: LobbyPlayer | null,
    ) {
        this.lobbyID = lobbyID;
        this.mode = mode;
        this.settings = settings;
        this.player1 = player1;
        this.player2 = player2;
    }
}
